import ajax from "../../authenticationSafeAjax";
import { RECOMMENDABLE_TYPE } from "../constants";

const fixedIncomeTypeMap = {
   "Bond": RECOMMENDABLE_TYPE.BOND,
   "Issuer": RECOMMENDABLE_TYPE.ISSUER,
   "Sovereignty": RECOMMENDABLE_TYPE.SOVEREIGNTY,
   "InterestRateFuture": RECOMMENDABLE_TYPE.INTEREST_RATE_FUTURE
};

export function searchForBondsUsingServer(searchTerm, responseCallback) {
    search("fixedincome", searchTerm, results => {
        results.forEach(result => {
            result.recommendableType = fixedIncomeTypeMap[result.type];
            result.instrumentId = result.asset_id;
            delete result.type;
        });
        responseCallback(results);
    });
}

export function searchForStockUsingServer(searchTerm, responseCallback) {
    search("equities", searchTerm, results => {
        results.forEach(result => {
            result.recommendableType = RECOMMENDABLE_TYPE.EQUITY;
            result.instrumentId = result.quoteId;
        });
        responseCallback(results);
    });
}

export function searchForFxPairUsingServer(searchTerm, responseCallback) {
    search("fx", searchTerm, results => {
        results.forEach(result => {
            result.recommendableType = RECOMMENDABLE_TYPE.FX_PAIR;
        });
        responseCallback(results);
    });
}

function search(searchUniverse, searchTerm, responseCallback) {
    const request = {
        url: `/recorder/api/search/${searchUniverse}?q=${searchTerm.trim()}`
    };

    ajax(request, (code, response) => responseCallback(JSON.parse(response)));
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/actions/searchForInstrumentsUsingServer.js
 **/